import * as z from 'zod'

export enum SubscriptionStatus {
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  TRIALING = 'trialing',
  ACTIVE = 'active',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
}

export enum SubscriptionPeriod {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  LIFETIME = 'lifetime',
  ONE_TIME = 'one_time',
}

export enum SubscriptionPlan {
  ROOKIE = 'Rookie',
  PRO = 'Conrad Pro',
  EXPERT = 'Conrad Expert',
  PREFERRED = 'Conrad Preferred',
  QLC_1 = '1 Qualified Lead Credit',
  QLC_5 = '5 Qualified Lead Credits',
  QLC_10 = '10 Qualified Lead Credits',
}

export enum StoreType {
  STRIPE = 'stripe',
  IOS = 'app_store',
}

export const subscriptionSchema = z.object({
  plan: z.nativeEnum(SubscriptionPlan),
  sneakCredits: z.number().int(),
  aiTokens: z.number().int(),
  aiMessages: z.number().int(),
  status: z.nativeEnum(SubscriptionStatus),
  currentPeriodEnd: z.string().datetime(),
  canceledAt: z.string().datetime().optional(),
  currentPeriodStart: z.string().datetime(),
  createdAt: z.string().datetime(),
  store: z.nativeEnum(StoreType),
})

export const pastPlansSchema = z.object({
  [SubscriptionPlan.PRO]: z.boolean(),
  [SubscriptionPlan.EXPERT]: z.boolean(),
})

export type SubscriptionData = z.infer<typeof subscriptionSchema>
